<template>
    <div>
        <v-breadcrumbs :items="items" :class="breadcrumbClass"></v-breadcrumbs>
    </div>
</template>

<script>
import "@/assets/css/color.css"; // CSS needs to be imported for each dashboard

export default {
    props: {
        extraBreadcrumb: {
            type: Array,
            default: () => []
        },
          classType: {
            type: String,
              default: "style1" // Default class type
        }
    },
    data() {
        return {
            items: [],
            emp_roles: []
        };
    },
    computed: {
        breadcrumbClass() {
            return this.classType === "style1" ? "breadcrumb-style1" : "breadcrumb-style2";
        }
    },
    mounted() {
        this.generateBreadcrumbs();
       
    },
   
    methods: {
        generateBreadcrumbs() {
            const rawLinks = sessionStorage.getItem("sblinks");
            const sblinks = rawLinks ? JSON.parse(rawLinks) : [];
            const currentPath = this.$route.path;
            const role = sessionStorage.getItem("para_role");
            const emp_roles = JSON.parse(sessionStorage.getItem("emp_role")) || {};

            const search_para_role = sessionStorage.getItem("search_para_role");
            const search_para_role_type = sessionStorage.getItem("search_para_role_type");
            const search_link = sessionStorage.getItem("search_link");


            // Start with Home
            this.items = [{ text: "Home", disabled: false, href: "/home-updated" }];


            // Fix: Add search parameters ONLY IF sblinks is empty
            if (sblinks.length === 0) {
                if (search_para_role_type) {
                    this.items.push({ text: search_para_role_type, disabled: true, href: "" });
                }
                if (search_para_role) {
                    this.items.push({ text: search_para_role, disabled: true, href: "" });
                }

                if (search_link) {
                    this.items.push({ text: search_link, disabled: true, href: "" });
                }
            }



            // Step 4: Check emp_roles
            if (Array.isArray(emp_roles.children) && emp_roles.children.length > 0) {
                this.items.push({
                    text: emp_roles.name,
                    disabled: false,
                    href: "/emp-role-dashboard",
                });
            } else if (typeof emp_roles === "object" && emp_roles.para_role_type) {
                this.items.push({
                    text: emp_roles.para_role_type,
                    disabled: true,
                    href: "",
                });
                if (emp_roles.para_role && !role) {
                    this.items.push({
                        text: emp_roles.para_role,
                        disabled: true,
                        href: "",
                    });
                    
                }
            }

            // Step 3: Add Role Dashboard if role exists
            if (role) {
                this.items.push({ text: role, disabled: false, href: "/role-dashboard" });
            }

            // Step 5: Restore Last Breadcrumb (Avoid Duplicates)
            let storedBreadcrumbs = JSON.parse(sessionStorage.getItem(`breadcrumbFlow_${role}`)) || [];
            storedBreadcrumbs.forEach((breadcrumb) => {
                if (!this.items.some(item => item.text === breadcrumb.text)) {
                    this.items.push(breadcrumb);
                }
            });

            // Step 6: Find the Current Path in sblinks
            const matchingItem = sblinks.find(item => currentPath.endsWith(item.link));
            if (matchingItem) {
                const formattedLink = matchingItem.link.startsWith("/role-dashboard")
                    ? matchingItem.link
                    : `/role-dashboard${matchingItem.link}`;

                if (!this.items.some(item => item.href === formattedLink)) {
                    this.items.push({
                        text: matchingItem.name,
                        disabled: false,
                        href: formattedLink
                    });

                    sessionStorage.setItem(`breadcrumbFlow_${role}`, JSON.stringify([{ text: matchingItem.name, href: formattedLink }]));
                }
            }

            // Step 7: Append extraBreadcrumb items
            this.items.push(...this.extraBreadcrumb);

            // Step 8: Always disable the last item
            if (this.items.length > 0) {
                this.items[this.items.length - 1].disabled = true;
            }
        }
        





    },
    watch: {
        "$route.path": {
            immediate: true,
            handler() {
                this.generateBreadcrumbs();
            }
        }
    }
};
</script>
<style scoped>
.breadcrumb-style1 {
    padding: 2px;
    margin-left: 45px;
    margin-top: -22px;
    font-size: medium;
    font-weight: bold;
}

.breadcrumb-style2 {
    padding: 2px;
    font-size: medium;
    font-weight: bold;
    margin-top: -34px;
    margin-left: 40px;
}
</style>
  

